/**
 * AMP 檢測輔助函數
 * 統一 Server 和 Client 的 AMP 檢測邏輯
 * 原本 Next 已有套件被使用，但在這些環節的變化不盡如意: CSR SSR with Hydration
 * 所以我們暫時加一套下去在 production 輸出 log 比較
 */

import { GetServerSidePropsContext } from 'next'

/**
 * Server Side AMP 檢測
 * 在 getServerSideProps 中使用
 */
export function detectAmpServerSide(context: GetServerSidePropsContext): boolean {
  const { query, req } = context

  // 檢查 URL 參數
  if (query.amp === '1') {
    return true
  }

  // 檢查 URL 路徑 - 添加 req 存在性檢查
  if (req?.url?.includes('/amp/')) {
    return true
  }

  // 檢查 User-Agent - 添加 req 和 headers 存在性檢查
  const userAgent = req?.headers?.['user-agent'] || ''
  if (userAgent.includes('Googlebot') && query.amp === '1') {
    return true
  }

  return false
}

/**
 * Client Side AMP 檢測
 * 在 React Component 中使用
 */
export function detectAmpClientSide(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  // 檢查 URL 查詢參數
  if (window.location.search.includes('amp=1')) {
    return true
  }

  // 檢查 URL 路徑
  if (window.location.pathname.includes('/amp/')) {
    return true
  }

  return false
}

/**
 * 統一的 AMP 檢測函數
 * 優先使用 Server Side 判斷，Client Side 備用
 */
export function detectAmp(serverSideIsAmp?: boolean): boolean {
  if (serverSideIsAmp !== undefined) {
    return serverSideIsAmp
  }

  return detectAmpClientSide()
}

/**
 * AMP 檢測的 getServerSideProps 輔助函數
 */
export function createAmpDetectionProps(context: GetServerSidePropsContext) {
  const isAmp = detectAmpServerSide(context)

  return {
    isAmp,
    ampUrl: isAmp ? context.req?.url : `${context.req?.url}${context.req?.url?.includes('?') ? '&' : '?'}amp=1`,
    canonicalUrl: isAmp ? context.req?.url?.replace('?amp=1', '').replace('&amp=1', '') : context.req?.url,
  }
}

